<template>
    <div>
        <div class="grid-content maintitle">
            <span>{{$t('message.货品管理')}}</span>
        </div>
        <div class="grid-content content-margin">
            <div class="buttonarea">
                <el-link :underline="false">
                    <el-button size="medium" round @click="createTarget">
                        <i class="iconfont">&#xe727;</i>
                        {{$t('message.新建')}}
                    </el-button>
                </el-link>
                <el-link :underline="false">
                    <el-button size="medium" round @click.native="refresh">
                        <i class="iconfont">&#xe667;</i>
                        {{$t('message.刷新')}}
                    </el-button>
                </el-link>
                <!-- <el-link
            :underline="false"
          >
            <el-button size="medium" round :loading="false" @click.native="exportDialogVisible = true">
              <i class="iconfont" >&#xe769;</i>
              导出
            </el-button>
          </el-link> -->
            </div>
        </div>

        <!-- 筛选栏开始 -->
        <div class="grid-content content-margin search-style">
            <table class="simpleRow">
                <tr>
                    <td>
                        <span class="simpleLabel">{{$t('message.筛选')}}</span>
                    </td>
                    <td>
                        <el-input clearable prefix-icon="el-icon-search" v-model="search" size="small" 
                            :placeholder="$t('message.输入关键字')" />
                    </td>
                    <td style="padding-left: 20px;">
                        <span class="simpleLabel">{{$t('message.品牌')}}</span>
                    </td>
                    <td>
                        <el-select size="small" v-model="selectedBrandID" :placeholder="$t('message.请选择')" clearable
                           >
                            <el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
                                :value="item.value" :disabled="item.disabled">
                            </el-option>
                        </el-select>
                    </td>
                </tr>
            </table>
        <!-- 筛选按钮开始 -->
        <div class="search-button"> 
            <div style="flex:0 0 80px;text-align:right"> </div>
            <div style="display:flex;">
              <el-button type="primary" @click="refresh" style="width:49%;box-sizing:border-box;border-radius: 14px;" class="br" size="mini" icon="el-icon-search">检索</el-button>
              <el-button type="danger"  @click="clear" style="width:49%;box-sizing:border-box;border-radius: 14px;" class="br" size="mini"  icon="el-icon-delete">清除</el-button>
            </div>
        </div>
            <!-- 筛选按钮结束 -->
        </div>
        <!-- 筛选栏结束 -->

        <div class="grid-content content-margin">
            <el-table ref="table" :data="tableData" stripe border :height="tableHeight" @sort-change="filterFunc"
                style="width: 100%;">
                <el-table-column fixed label="No." type="index" :index='indexm' width="55">
                </el-table-column>
                <el-table-column fixed width="160" :label="$t('message.操作')" align="center">
                    <template slot-scope="scope">
                        <el-button-group>
                            <el-button size="mini" round type="normal" icon="el-icon-zoom-in"
                                @click="editTarget(scope.row, false)"></el-button>
                            <el-button size="mini" round type="normal" icon="el-icon-edit"
                                @click="editTarget(scope.row, true)"></el-button>
                            <el-button size="mini" round type="normal" icon="el-icon-delete"
                                @click="targetRow = scope.row; deleteDialogVisible = true;"></el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
                <el-table-column fixed width="160" label="库存" align="center">
                    <template slot-scope="scope">
                            <el-button size="mini"  type="normal" 
                                @click="getStore(scope.row)">查看门店库存</el-button>
                            
                    </template>
                </el-table-column>
                <el-table-column sortable prop="commodityid" :label="$t('message.产品ID')" width="150">
                </el-table-column>
                <el-table-column sortable prop="name" :label="$t('message.产品名称')" min-width="150">
                </el-table-column>
                <el-table-column sortable prop="price" :label="$t('产品价格')" min-width="150">
                </el-table-column>
                
                <el-table-column label="产品图片344*min（100）" width="250" align="center">
                    <template slot-scope="scope">
                        <el-popover v-if="scope.row.img != ''" placement="top-start" title="" trigger="hover">
                            <img :src="'' + scope.row.img" alt="" style="max-width: 500px; max-height: 500px">
                            <img slot="reference" :src="'' + scope.row.img" style="max-width: 120px; max-height: 30px">
                        </el-popover>
                        <span v-else>{{$t('message.无')}}</span>
                    </template>
                </el-table-column>
               
                <el-table-column sortable prop="editdate" :label="$t('message.更新日期')" min-width="160">
                </el-table-column>

            </el-table>
            <!-- 放置分页组件区域 -->
            <pagination :pagesizeList='pageConfig.pagesizeList' :pagesize='sendData.pageConfig.pagesize'
                :total='pageConfig.total' :page='sendData.pageConfig.page'></pagination>
        </div>

        <el-dialog :title="$t('message.删除确认')" :visible.sync="deleteDialogVisible" width="300px" :modal="false" center
            :before-close="handleClose">
            <i class="iconfont">&#xe766;</i>
            <span>{{$t('message.请确认是否删除该产品')}}</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteDialogVisible = false">{{$t('message.取消')}}</el-button>
                <el-button type="primary" @click.native="deleteTarget">{{$t('message.删除')}}</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="$t('message.导出')" :visible.sync="exportDialogVisible" width="300px" :modal="false" center>
            <span style="display: inline-block;">{{$t('message.请确认是否导出')}}</span>
            <!-- show-checkbox
          :check-on-click-node="true"
          :check-strictly="true" -->
            <!-- @node-click="handleNodeClick" -->
            <span slot="footer" class="dialog-footer">
                <el-link :underline="false">
                    <el-button @click="exportDialogVisible = false">{{$t('message.取消')}}</el-button>
                </el-link>
                <el-link :href="'/manage/wechat/downloadtagusers'" :underline="false">
                    <el-button type="primary" @click.native="exportTag">{{$t('message.导出')}}</el-button>
                </el-link>
            </span>
        </el-dialog>
        <modalreal :zIndexEdit='false' :width='600' :height='400' v-if="showStore">
      <div slot="title">
        {{prodId.name}}库存列表
      </div>
      <div style="flex:1" slot="contner">
        <div class="grid-content content-margin">
            <shopSelectionProd :tableData='[]' :prodID='prodId'></shopSelectionProd>
        </div>
      </div>
      <div class="footer" slot="foter">
        <el-button @click="showStore=false" size="mini">取消</el-button>
        <!-- <el-button @click="dosavecoor(0)" type="primary" size="mini">保存</el-button> -->
        <el-button @click="showStore=false" type="primary" size="mini">保存</el-button>

      </div>
    </modalreal>
    </div>
</template>

<script>
import commonUtil from "@/utils/commonUtil";
// 分页模块
import pagination from "@/components/pagination/pagination";
import shopSelectionProd from "@/components/elementSelect/shopSelectionProd";
import { rejecthttp, changeflagCLOSED } from "@/utils/request";
  import modalreal from '@/components/modalCom/modalreal'

export default {
    name: "BrandTypeList",
    components: {
        pagination,
        shopSelectionProd,
        modalreal
    },
    data() {
        return {
            tableHeight: 500,
            typeOptions: [
                {
                    value: "0",
                    label: "加载中..",
                    disabled: true,
                },
            ],
            selectedBrandID: "",
            filterText: "",
            tempName: "",
            deleteDialogVisible: false,
            exportDialogVisible: false,
            targetRow: null,
            tableData: [],
            search: "",
            // 分页数据配置
            pageConfig: {
                pagesizeList: [10, 20, 50, 100],
                pageSize: 10,
            },
            sendData: {
                appID: 188,
                filterConfig: {
                    keyword: '',
                    // brantypedID: 0
                },
                pageConfig: {
                    page: 1,
                    pagesize: 20,
                    pageStartIndex: 0
                },
                sortConfig: {
                    order: '',
                    prop: ''
                }
            },
            showStore:false,
            prodId:{
                data:-1,
                name:''
            }
        };
    },
    mounted: function () {
        this.$nextTick(function () {
            if (this.$refs.table.$el !== "undefined")
                this.tableHeight =
                    window.innerHeight - this.$refs.table.$el.offsetTop - 195;

            // 监听窗口大小变化
            let self = this;
            window.onresize = function () {
                self.tableHeight =
                    window.innerHeight - self.$refs.table.$el.offsetTop - 195;
            };
        });
        //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
    },
    watch: {},
    methods: {
        getStore(e){
            this.prodId={
                data:e.commodityid,
                name:e.name
            }
            this.showStore=true
            console.log(e)
        },
    clear(){
        this.search='',
        this.selectedBrandID='',
        this.sendData.filterConfig.keyword=''
        this.sendData.filterConfig.brandID=0
        this.refresh()
      },
        indexm(i) {
            return (this.sendData.pageConfig.pagesize * (this.sendData.pageConfig.page - 1) + 1 + i)
        },
        // 子组件调用的方法，分页模块
        paginationChange(pagesize, page, name) {
            console.log(pagesize, page);
            this.sendData.pageConfig.page = page != -1 ? page : this.sendData.pageConfig.page
            this.sendData.pageConfig.pagesize = pagesize != -1 ? pagesize : this.sendData.pageConfig.pagesize
            this.refresh()
        },
        // 排序的回调
        filterFunc(config) {
            // 获取点击的dom保存下来，等待翻页后继续留用
            // 获取dom元素
            this.sendData.pageConfig.page = 1
            this.sendData.sortConfig.order = config.order
            this.sendData.sortConfig.prop = config.prop
            this.refresh()
            // 保存排序的dom标签
            // this.clickDom=orderDom
        },
        refresh() {
            // 关键字及和筛选条件的赋值
            this.sendData.filterConfig.keyword = this.search
            rejecthttp(false, 'post', "/manage/commodity/getcommoditylist", this.sendData, this, (doc) => {
                changeflagCLOSED(doc, 0, this)
                if (doc.data.Code == "MSGKEY_OK") {
                    console.log(doc.data);
                    // 添加总条数
                    this.pageConfig.total = doc.data.exData.datas
                    this.tableData = doc.data.data;
                    this.tableData.forEach((any) => {
                        any.editdate = commonUtil.formatDate(any.editdate);
                    });
                }
            });
            // this.$http
            //   .post("/manage/product/getproductlist", this.sendData)
            //   .then((doc) => {
            //     if (doc.data.Code != "MSGKEY_OK") {
            //       this.$message({
            //         type: "error",
            //         message: doc.data.Message,
            //       });
            //     } else {
            //       console.log(doc.data);
            //       // 添加总条数
            //       this.pageConfig.total=doc.data.exData.datas
            //       this.tableData = doc.data.data;
            //       this.tableData.forEach((any) => {
            //         any.editdate = commonUtil.formatDate(any.editdate);
            //       });
            //     }
            //   });
        },
        exportAll() {
            rejecthttp(true, 'get', "/manage/product/getproductlist", {}, this, (doc) => {
                changeflagCLOSED(doc, 0, this)
                if (doc.data.Code == "MSGKEY_OK") {
                    this.tableData = doc.data.data;
                }
            });
            // this.$http.get("/manage/wechat/exporttags", {}).then((doc) => {
            //   // console.log(doc.data)
            //   if (doc.data.Code != "MSGKEY_OK") {
            //     this.$message({
            //       type: "error",
            //       message: doc.data.Message,
            //     });
            //   } else {
            //     this.tableData = doc.data.data;
            //   }
            // });
        },
        createTarget() {
            this.$router.push({ name: "goodsDetail", query: { appid: "188" } });
        },
        editTarget(data, edit) {
            this.$router.push({
                name: "goodsDetail",
                query: { id: data.commodityid, appid: "188", isEditMode: edit },
            });
        },
        deleteTarget() {
            console.log('我来查看删除哪一行数据')
            console.log(this.targetRow);
            rejecthttp(
                true,
                "get",
                "/manage/commodity/deletecommodity",
                {
                    appid: 188,
                    commodityid: this.targetRow.commodityid,
                },
                this,
                (doc) => {
                    changeflagCLOSED(doc, 1, this);
                    if (doc.data.Code == "MSGKEY_OK") {
                        this.$message({
                            type: "success",
                            message: this.$t("删除货品成功"),
                        });
                    }
                    this.deleteDialogVisible = false;
                    this.refresh();
                }
            );
        },
        getBrandName(id) {
            let result = "未选择";
            this.typeOptions.forEach((item) => {
                if (parseInt(item.value) == parseInt(id)) return (result = item.label);
            });
            return result;
        },
        getProductStateName(state) {
            return commonUtil.getProductStateName(state);
        },
        getRecommendFlagName(flag) {
            return commonUtil.getRecommendFlagName(flag);
        },
        handleClose(done) {
            // 空函数, 防止dialog被不小心关闭
        },
    },
    created() {
        this.refresh();
    },
    computed: {
        filterData() {
            if (this.tableData)
                return this.tableData.filter(
                    (data) =>
                        (!this.search ||
                            data.name.toLowerCase().includes(this.search.toLowerCase()) ||
                            data.shelvesinfo
                                .toLowerCase()
                                .includes(this.search.toLowerCase()) ||
                            data.jumpurl.toLowerCase().includes(this.search.toLowerCase())) &&
                        (!this.selectedBrandID || data.brandid == this.selectedBrandID)
                );
            else return [];
        },
    },
};
</script>

<style scoped>
.el-table /deep/ td {
    user-select: text !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/products/GoodsList.vue